module.exports = __webpack_public_path__ + "img/JOINT_ATTACK_A1010.2d1485b8.png";